import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Assemble des classes Tailwind ; en cas de conflit (px-4 / px-2), la dernière l'emporte. */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
